import React, { useEffect, useState } from 'react';
import UndoNotification from './UndoNotification';

const NotificationManager = () => {
  const [notifications, setNotifications] = useState([]);

  // Subscribe to custom events for notifications
  useEffect(() => {
    // Function to handle adding new notifications
    const handleAddNotification = (event) => {
      const { detail } = event;
      
      if (!detail || !detail.id) return;
      
      setNotifications(prev => [...prev, {
        ...detail,
        id: detail.id || `notification-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
      }]);
    };

    // Function to handle removing notifications
    const handleRemoveNotification = (event) => {
      const { detail } = event;
      if (!detail || !detail.id) return;
      
      setNotifications(prev => prev.filter(n => n.id !== detail.id));
    };
    
    // Add event listeners
    window.addEventListener('add-notification', handleAddNotification);
    window.addEventListener('remove-notification', handleRemoveNotification);
    
    // Cleanup
    return () => {
      window.removeEventListener('add-notification', handleAddNotification);
      window.removeEventListener('remove-notification', handleRemoveNotification);
    };
  }, []);

  // Helper to remove a notification
  const removeNotification = (id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  return (
    <div className="notification-manager">
      {notifications.map(notification => {
        // Render different notification types based on the type property
        if (notification.type === 'undo') {
          return (
            <UndoNotification
              key={notification.id}
              operationId={notification.operationId}
              message={notification.message}
              expiresAt={notification.expiresAt}
              onUndo={notification.onUndo}
              onClose={() => removeNotification(notification.id)}
              onExpire={() => removeNotification(notification.id)}
              autoHideDuration={notification.autoHideDuration || 10000}
            />
          );
        }
        
        // Add other notification types as needed
        return null;
      })}
    </div>
  );
};

// Helper functions to be exported and used elsewhere
export const addNotification = (notification) => {
  const id = notification.id || `notification-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  
  window.dispatchEvent(new CustomEvent('add-notification', {
    detail: {
      ...notification,
      id
    }
  }));
  
  return id;
};

export const removeNotification = (id) => {
  window.dispatchEvent(new CustomEvent('remove-notification', {
    detail: { id }
  }));
};

export const addUndoNotification = ({
  operationId,
  message,
  expiresAt,
  onUndo,
  autoHideDuration = 10000
}) => {
  return addNotification({
    type: 'undo',
    operationId,
    message,
    expiresAt,
    onUndo,
    autoHideDuration
  });
};

export default NotificationManager;